import React from "react"
import Link from "gatsby-link";
import Img from 'gatsby-image';

export default ({post, author}) => (
    <header className="entry-header">
        <h1 className="entry-title"><span dangerouslySetInnerHTML={{ __html: post.title }} /></h1>
        <div className="entry-meta">
            {post.date && <span>
                <span className="screen-reader-text">Posted on</span> <time className="entry-date published" dateTime={post.date}>{post.date}</time>
                    <time className="updated" dateTime={post.updatedAt}>{post.updatedAt}</time>
            </span>}
            {author && <span className="byline">
                <span className="author vcard">
                    <Img resolutions={author.image.resolutions} className="avatar avatar-24 photo" />
                    <span className="screen-reader-text">Author </span> <span className="url fn n">{author.name}</span>
                </span>
            </span>}
        </div>
    </header>
)


// WEBPACK FOOTER //
// ./src/components/PostHeader.js